import Image from "next/image";
import HowWorksCard from "./HowWorksCard";
import SectionHeading from "../SectionHeading";

const workingProcesses = [
  {
    imageSrc: "/assets/pet-tag/process-lost.png",
    title: "1. If Your Pet Gets Lost",
    description:
      "The QR code on the AmarPet Tag links to your pet’s detailed profile, making it easy for anyone who finds them to help.",
  },
  {
    imageSrc: "/assets/pet-tag/process-scan.png",
    title: "2. Scan the AmarPet Tag",
    description:
      "When someone finds your pet, they can scan the QR code to instantly access your contact details and important care information.",
  },
  {
    imageSrc: "/assets/pet-tag/process-share.png",
    title: "3. Share location",
    description:
      "Finders can quickly share their location, and you’ll be notified immediately via email and app alerts.",
  },
  {
    imageSrc: "/assets/pet-tag/process-reunite.png",
    title: "4. Reunite Safely",
    description:
      "With the finder’s contact information and location, arranging a quick and safe reunion with your pet becomes simple.",
  },
];

function PetTagHowWorks() {
  return (
    <section className="py-[3.5rem] ">
      <SectionHeading title="How Does It Work?" className="mb-[3.75rem]" />
      <div className="relative mx-auto w-fit px-[2.5rem] rounded-2xl border-[2px] border-white bg-[#ffffffbf] flex flex-row justify-center pb-[5rem]">
        <div className="w-[700px] h-[350px] top-[3rem] absolute lg:-top-[9rem] lg:w-[800px] lg:h-[800px] rotate-90 -z-10">
          <Image
            src="/assets/pet-tag/process-bg.png"
            fill
            quality={30}
            alt="pet"
          />
        </div>
        <div className="w-[700px] h-[350px] bottom-[3rem] absolute lg:hidden rotate-90 -z-10">
          <Image
            src="/assets/pet-tag/process-bg.png"
            fill
            quality={30}
            alt="pet"
          />
        </div>
        <div className="flex flex-col gap-[2rem] lg:flex-row">
          {workingProcesses.map((process, index) => {
            return <HowWorksCard key={index} {...process} />;
          })}
        </div>
      </div>
    </section>
  );
}

export default PetTagHowWorks;
